<template>
  <div class="Location">
  </div>
</template>

<script>

export default {
  name: "LocationMeiroma",
  mounted() {
    location.href="https://puri.sega.jp/location-map/?id=108";
  }
}
</script>

<style scoped>
</style>
